import React, {useState} from 'react';
import WorkShiftAccessCard from '../Modal/WorkShiftAccessCard';
import AssignedEmployees from './AssignedEmployees';
import Access from './Access';
import { permissionObj } from '../../../../../Helpers/permission';
import { useSelector } from 'react-redux';

/**
 * DEV - IBL
 * Autor: Ferro Zapata Arnulfo
 * Full Stack development
 * @param setRemoveUserModal
 * @param id
 * @returns {JSX.Element}
 * @constructor
 */

const WorkShiftCardDetails = ({ id, currentKey, DEV }) => {
    const permission = useSelector((state) => state.authenticatioauthennSlice.permission);
    const [modified, setModified] = useState(false);
    return (
        <>
            {(DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_CREATE)) &&
                <WorkShiftAccessCard
                    id={id}
                    setModified={setModified}
                />
            }
            <Access
                id={id}
                modified={modified}
                setModified={setModified}
            />
            <AssignedEmployees
                id={id}
            />
        </>
    );
};

export default WorkShiftCardDetails;
